import { render, staticRenderFns } from "./appMenuNew.vue?vue&type=template&id=83e5402c&scoped=true&"
import script from "./appMenuNew.vue?vue&type=script&lang=js&"
export * from "./appMenuNew.vue?vue&type=script&lang=js&"
import style0 from "./appMenuNew.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./appMenuNew.vue?vue&type=style&index=1&id=83e5402c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83e5402c",
  null
  
)

export default component.exports